import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ContentControlAssetsHubComponent } from "./assets-hub/content-control-assets-hub/content-control-assets-hub.component";
import { ContentControlRoutes } from "./content-control.routes";
import { RouterModule } from "@angular/router";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { AgGridModule } from "ag-grid-angular";
import { ContentControlAssetsHubEditCellComponent } from "./assets-hub/content-control-assets-hub/content-control-assets-hub-edit-cell/content-control-assets-hub-edit-cell.component";
import { IContentControlManager } from '../../domain/content-control/manager';
import { ContentControlManagerImpl } from "../../infrastructure/content-control/content-control-manager.service";
import { IContentControlRepository } from '../../domain/content-control/repository';
import { ContentControlRepositoryImpl } from "../../infrastructure/content-control/content-control-repository.service";
import { FormsModule } from "@angular/forms";
import { ContentControlStudioModule } from "./studio/content-control-studio/content-control-studio.module";
import { ContentManagerGuard } from "../../guards/permission.guard";
import { MatButtonModule } from "@angular/material/button";
import { ReactiveFormsModule } from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";
import { MatCardModule } from "@angular/material/card";
import { ContentControlOperationRoomComponent } from "./operation-room/content-control-operation-room.component";
import { IAiJobsRepository } from '../../domain/content-control/ai-jobs';
import { AiJobsRepository } from "../../infrastructure/content-control/ai-jobs-repository.service";
import { ContentControlOpertationRoomChannelComponent } from "./operation-room/content-control-opertation-room-assets-manager/content-control-opertation-room-channel/content-control-opertation-room-channel.component";
import { ContentControlOpertationRoomAssetsManagerComponent } from "./operation-room/content-control-opertation-room-assets-manager/content-control-opertation-room-assets-manager.component";
import { InlineSVGModule } from "ng-inline-svg-2";
import { ContentControlOperationRoomPlayerComponent } from "./operation-room/content-control-operation-room-player/content-control-operation-room-player.component";
import { ToastrModule } from "ngx-toastr";
@NgModule({
  declarations: [
    ContentControlAssetsHubComponent,
    ContentControlAssetsHubEditCellComponent,
    ContentControlOperationRoomComponent,
    ContentControlOpertationRoomAssetsManagerComponent,
    ContentControlOpertationRoomChannelComponent,
    ContentControlOperationRoomPlayerComponent,
    ContentControlAssetsHubEditCellComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    EvrideoCommonModule,
    InlineSVGModule.forRoot(),
    RouterModule.forRoot(ContentControlRoutes, {
      onSameUrlNavigation: "reload",
    }),
    AgGridModule,
    ContentControlStudioModule,
    MatButtonModule,
    MatRadioModule,
    MatCardModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 2000,
    }),
  ],
  providers: [
    ContentManagerGuard,
    {
      provide: IContentControlManager,
      useClass: ContentControlManagerImpl,
    },
    {
      provide: IContentControlRepository,
      useClass: ContentControlRepositoryImpl,
    },
    {
      provide: IAiJobsRepository,
      useClass: AiJobsRepository,
    },
  ],
})
export class ContentControlModule {}
